// src/components/ai/RecipeCard.jsx

import React from 'react';
import { Card, CardBody } from '../../components/card/card.jsx';
import glassshimmer from '../../assets/images/glassshimmer.png';


export default function RecipeCard({ recipe, onClick, className = '' }) {
  if (!recipe) return null

  // Truncate preview at 100 chars
  const MAX_PREVIEW = 300
  const fullDesc = recipe.description || ''
  const previewDesc =
    fullDesc.length > MAX_PREVIEW
      ? fullDesc.slice(0, MAX_PREVIEW).trim() + '…'
      : fullDesc

  // image fallback
  const imgUrl = recipe.image?.url || glassshimmer
  const imgAlt = recipe.image?.alt || recipe.name || 'Recipe image'

  return (
    <Card
      role="button"
      onClick={e => {
        e.preventDefault()
        onClick(recipe)
      }}
      className={`h-100 d-flex flex-column cursor-pointer text-body text-decoration-none ${className}`}
      tabIndex={0}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          onClick(recipe)
        }
      }}
      aria-label={`View recipe details for: ${recipe.name}`}
    >
      {/* Grow this body to push the button to the bottom */}
      <CardBody className="p-4 d-flex flex-column flex-grow-1">
        <img
          src={imgUrl}
          alt={imgAlt}
          className="img-fluid rounded mb-3"
          style={{ backgroundColor: '#fff' }}
        />

        <h5 className="mb-2 text-truncate">{recipe.name}</h5>

        {/* Flex-grow the description so button is always bottom-aligned */}
        <p className="text-body text-opacity-75 mb-3 flex-grow-1">
          {previewDesc}
        </p>

        <button
          type="button"
          className="btn btn-sm btn-outline-theme mt-auto"
          onClick={e => {
            e.stopPropagation()
            onClick(recipe)
          }}
        >
          View Recipe
        </button>
      </CardBody>

      {/* optional card-arrows if you have them */}
      <div className="card-arrow">
        <div className="card-arrow-top-left" />
        <div className="card-arrow-top-right" />
        <div className="card-arrow-bottom-left" />
        <div className="card-arrow-bottom-right" />
      </div>
    </Card>
  )
}
